module.exports = __webpack_public_path__ + "static/media/sla-management-freshservice.6049e743.svg";